import {createProgram} from "../primitiveHelpers.js";
import {primitiveFragShader, primitiveVertShader} from "../shaders/primitiveShader.js";
import mapboxgl from "mapbox-gl";
import * as THREE from "three";
import {getScalingFactor} from "../helpers.js";
import Stats from "three/addons/libs/stats.module.js";
import axios from "axios";
import {PositionParser} from "../utils/positionParser.js";
import {getPlateIndex, roundDownToNearest5} from "../helpers/index.js";

let program;
let vbop;
let vboc;
let plateCreated = false;
let statsPanels;

// const anchor = [-61.7964, 17.0608];
const anchor = [-5, 51];
const plateSize = 1_000_000;
const earthRadius = 1303.797293808806;


function binarySearch(array, x) {
    let lo = -1;
    let hi = array.length;
    let mid;

    while (hi - lo > 1) {
        mid = (lo + hi) >> 1;

        if (array[mid].at <= x) {
            lo = mid;
        } else {
            hi = mid;
        }
    }

    if (array[lo] === x) hi = lo;

    return lo === -1 ? hi : lo;
}

let loaded = false;
const glcache = {};
let map;

let x = 1690030000;  //fastnet

const plates = [];
const plateSize2 = 5;
const latMin = -90;
const latMax = 90;
const lngMin = -180;
const lngMax = 180;

let plateTexture;


function splitAtDateline(points) {
    const newPoints = [];

    for (let i = 0; i < points.length - 1; i += 2) {
        const point1 = points[i];
        const point2 = points[i + 1];

        // if (point1.team !== point2.team) {
        //     continue;
        // }

        const lon1 = point1.lon;
        const lat1 = point1.lat;

        const lon2 = point2.lon;
        const lat2 = point2.lat;

        newPoints.push({ ...point1 });

        if (Math.abs(lon1 - lon2) > 180) {
            const crossLon = lon1 > 0 ? 180 : -180;
            let lon2Adjusted = lon2;

            if (lon2 < 0 && lon1 > 0) lon2Adjusted = lon2 + 360;
            if (lon2 > 0 && lon1 < 0) lon2Adjusted = lon2 - 360;

            const ratio = (crossLon - lon1) / (lon2Adjusted - lon1);
            const latIntercept = lat1 + ratio * (lat2 - lat1);

            newPoints.push({
                ...point1,
                lon: crossLon,
                lat: latIntercept,
            });

            newPoints.push({
                ...point1,
                lon: -crossLon,
                lat: latIntercept,
            });
        }
        else if ((lon1 < 0 && lon2 > 0) || (lon1 > 0 && lon2 < 0)) {
            const ratio = -lon1 / (lon2 - lon1);
            const latIntercept = lat1 + ratio * (lat2 - lat1);

            if ((lon1 < 0 && lon2 > 0) ) {
                newPoints.push({
                    ...point1,
                    lon: -0.0001,
                    lat: latIntercept,
                });
                newPoints.push({
                    ...point1,
                    lon: 0.0001,
                    lat: latIntercept,
                });
            } else {
                newPoints.push({
                    ...point1,
                    lon: 0.0001,
                    lat: latIntercept,
                });
                newPoints.push({
                    ...point1,
                    lon: -0.0001,
                    lat: latIntercept,
                });
            }
        }

        newPoints.push({ ...point2 });
    }

    return newPoints;
}



export const getUberLinePrimitiveLayer = (data, holder, setup) => {
    const splitData = splitAtDateline(data.filter(({team}) => team !== 4));

    console.log("TEST", splitData.findIndex(data => data.lon === -10))
    console.log("splitData", splitData)
    return {
        id: 'uber-line-primitive-layer',
        type: 'custom',
        onAdd: (m, gl) => {

            for (let lat = latMin; lat < latMax; lat += plateSize2) {
                for (let lng = lngMin; lng < lngMax; lng += plateSize2) {
                    const swLat = lat;
                    const swLng = lng;
                    const neLat = Math.min(lat + plateSize2, latMax);
                    const neLng = Math.min(lng + plateSize2, lngMax);

                    plates.push({
                        coords:[[swLat, swLng], [neLat, neLng]],
                        plate: new mapboxgl.LngLatBounds(
                          [ swLng, swLat],
                          [ neLng, neLat]
                        )
                    });
                }
            }


            const plateArray = new Float32Array(162 * 16 * 16);

            plates.forEach(({ plate, coords }, i) => {
                const nw_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getNorthWest(), 0);
                const sw_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getSouthWest(), 0);
                const ne_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getNorthEast(), 0);


                const tl_up = new THREE.Vector3().fromArray(plate.getNorthWest().toEcef(0));
                const br_up = new THREE.Vector3().fromArray(plate.getSouthWest().toEcef(0));
                const tr_up = new THREE.Vector3().fromArray(plate.getNorthEast().toEcef(0));
                const bl_up = new THREE.Vector3().fromArray(plate.getSouthEast().toEcef(0));


                const tl =  new THREE.Vector3(nw_merc.x, nw_merc.y, nw_merc.z);
                const tr =  new THREE.Vector3(ne_merc.x, ne_merc.y, ne_merc.z);
                const bl =  new THREE.Vector3(sw_merc.x, sw_merc.y, sw_merc.z);


                const offset = i * 16;

                plateArray.set([
                    tl.x,
                    tl.y,
                    tr.x,
                    bl.y,

                    tl_up.x, tl_up.y, tl_up.z,
                    tr_up.x, tr_up.y, tr_up.z,
                    br_up.x, br_up.y, br_up.z,
                    bl_up.x, bl_up.y, bl_up.z
                ], offset);
            });

            plateTexture = new THREE.DataTexture(
              plateArray,
              256, 162,
              THREE.RedFormat,
              THREE.FloatType
            );
            plateTexture.needsUpdate = true;


            map = m;

            vbop = gl.createBuffer();
            vboc = gl.createBuffer();

            program = createProgram(gl, primitiveVertShader, primitiveFragShader);

            const stats1 = new Stats();
            stats1.showPanel(0);
            document.body.appendChild(stats1.dom);

            const stats2 = new Stats();
            stats2.showPanel(1);
            stats2.dom.style.left = '80px';
            document.body.appendChild(stats2.dom);

            const stats3 = new Stats();
            stats3.showPanel(2);
            stats3.dom.style.left = '160px';
            document.body.appendChild(stats3.dom);
            statsPanels = [stats1, stats2, stats3];


            const width = 256;
            const height = 162;

            plateTexture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, plateTexture);
            gl.texImage2D(
              gl.TEXTURE_2D,
              0,
              gl.R32F,
              width, height,
              0,
              gl.RED,
              gl.FLOAT,
              plateArray
            );


            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);


        },
        render: (gl, projectionMatrix, projection, globeToMercMatrix, transition, centerInMercator, pixelsPerMeterRatio) => {

            statsPanels.forEach(stats => stats.begin());

            if (setup && !loaded) {

                loaded = true;

                console.log("SETUP!");

                const pb = new Float32Array(splitData.length * 3);
                const cb = new Float32Array(splitData.length * 3);

                let px = 0;
                let cx = 0;

                for (let i = 0; i < splitData.length; i++) {

                    const record = splitData[i];

                    const lon = record.lon;
                    const lat = record.lat;

                    const merc = mapboxgl.MercatorCoordinate.fromLngLat([lon, lat], 0);

                    const roundedDown = roundDownToNearest5({
                        x: lon, y: lat
                    });


                    pb[px++] = merc.x;
                    pb[px++] = merc.y;
                    pb[px++] = getPlateIndex(roundedDown);

                    const team = holder[record.team];

                    cb[cx++] = team.r;
                    cb[cx++] = team.g;
                    cb[cx++] = team.b;

                }

                gl.bindBuffer(gl.ARRAY_BUFFER, vbop);
                gl.bufferData(gl.ARRAY_BUFFER, pb, gl.DYNAMIC_DRAW);

                gl.bindBuffer(gl.ARRAY_BUFFER, vboc);
                gl.bufferData(gl.ARRAY_BUFFER, cb, gl.DYNAMIC_DRAW);
            }

            gl.useProgram(program);

            gl.bindBuffer(gl.ARRAY_BUFFER, vbop);
            activateAttrib(gl, program, 'position', 3);

            gl.bindBuffer(gl.ARRAY_BUFFER, vboc);
            activateAttrib(gl, program, 'colour', 3);

            setUniform(gl, program, "projectionMatrix", projectionMatrix);


            const location = gl.getUniformLocation(program, "u_plates");

            const mapCenter = map.getCenter();
            const nearDateLine = mapCenter.lng > 100 ||  mapCenter.lng < -100;
            const crossedDateLine = mapCenter.lng > 0;


            setUniform(gl, program, "u_near_dateline", nearDateLine)
            setUniform(gl, program, "u_crossed_dateline", crossedDateLine)


            gl.activeTexture(gl.TEXTURE0);
            gl.bindTexture(gl.TEXTURE_2D, plateTexture);
            gl.uniform1i(location, 0);


            if (projection && projection.name === 'globe') {

                if (!plateCreated) {

                    setUniform(gl, program, "u_scale_factor", getScalingFactor(anchor[1]))
                    setUniform(gl, program, "u_plate_up_scale", earthRadius)

                    plateCreated = true;

                }

                setUniform(gl, program, "u_matrix_globe_merc", globeToMercMatrix);
                setUniform(gl, program, "u_zoom_transition", transition);
                setUniform(gl, program, "u_pixelsPerMeterRatio", pixelsPerMeterRatio);
                setUniform(gl, program, "u_centerInMerc", centerInMercator);

            } else {

                setUniform(gl, program, "u_zoom_transition", 1);

            }

            const i = binarySearch(splitData, window.x);

            //Just one draw call 8-)
            gl.drawArrays(gl.LINES, 0, i);

            if (map.getZoom() > 10) {

                gl.drawArrays(gl.POINTS, 0, i);

            }

            statsPanels.forEach(stats => stats.end());
        }

    }
}


function activateAttrib(gl, program, attribName, size) {

    const attribLoc = glcache[attribName] = glcache[attribName] || gl.getAttribLocation(program, attribName);

    gl.vertexAttribPointer(attribLoc, size, gl.FLOAT, false, 0, 0);
    gl.enableVertexAttribArray(attribLoc);
}

function setUniform(gl, program, uniformName, value) {

    const location = glcache[uniformName] = glcache[uniformName] || gl.getUniformLocation(program, uniformName);

    if (!location) {
        console.warn(`Uniform ${uniformName} not found`);
        return;
    }

    if (value instanceof THREE.Matrix4) {

        gl.uniformMatrix4fv(location, false, value.elements);

    } else if (Array.isArray(value) && value.length === 16) {

        gl.uniformMatrix4fv(location, false, value);

    } else if (Array.isArray(value) && value.length === 2) {

        gl.uniform2fv(location, value);

    } else if (value instanceof THREE.Vector3) {
        gl.uniform3fv(location, value.toArray());
    } else if (value instanceof THREE.Vector2) {
        gl.uniform2fv(location, value.toArray());
    } else if (typeof value === "number") {
        gl.uniform1f(location, value);
    } else if (typeof value === "boolean") {
        gl.uniform1i(location, value ? 1 : 0);
    } else {
        console.error(`Incorrect uniform type for ${uniformName}`);
    }
}